import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import * as Types from './purchasePlus_graphql'

export const ProductSellPackProductFragmentDoc = gql`
  fragment ProductSellPackProduct on Product {
    id
    stockItem
    itemSellPackName
    itemSellQuantity
  }
` as unknown as DocumentNode<Types.ProductSellPackProductFragment, unknown>
